import { useEffect, useState } from "react";
import { Alert, Col, Fade, Modal, Row } from "react-bootstrap";
import DefaultButton from "../../../../../components/buttons/default-button/DefaultButton";


interface uidModalProps {
    visible: boolean
    onHide: () => void
    reGenerateUUID: () => void
    username: string
    rtrComment: string
}

export default function UidModal({visible, onHide, reGenerateUUID, username, rtrComment}: uidModalProps) {
    const [showSuccess, setShowSucces] = useState(false)

    useEffect(() => {
        let throttle: string | number | NodeJS.Timeout | undefined

        if(showSuccess) {
            throttle = setTimeout(() => {
                setShowSucces(false)
            }, 1000)
        }

        return(() => {
            clearTimeout(throttle)
        })
    }, [ showSuccess ])

    return(
        <Modal
            show={ visible }
            onHide={() => {
                setShowSucces(false)
                onHide()
            }}
            fullscreen="md-down"
            dialogClassName="modal-90w"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title style={{textAlign: "center"}}>
                    <span>UUID kód:</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row style={{alignItems: "center"}}>
                    <Col>
                       <span>Felhasználó: </span>
                       <b>{username}</b>
                    </Col>
                </Row>

                <Row style={{alignItems: "center"}}>
                    <Col>
                       <span>Secret:</span>
                    </Col>
                </Row>

                <Row style={{marginBottom:"10px", alignItems: "center"}}>
                    <Col>
                        <b>
                            {rtrComment}
                        </b>
                    </Col>
                </Row>

                <Row style={{ textAlign: "center"}}>
                    <Col>
                        <DefaultButton title={"UUID másolása"} onClick={e => {
                            e.preventDefault()
                            navigator.clipboard.writeText(rtrComment)
                            setShowSucces(true)
                        }} />
                    </Col>
                    <Col>

                        <DefaultButton
                            title={"UUID Újragenerálása"}
                            onClick={e => {
                                e.preventDefault()
                                reGenerateUUID()
                            }}
                        />
                    </Col>
                </Row>

                <Alert style={{marginTop: "10px"}} show={showSuccess} transition={Fade} key={rtrComment} variant={"success"}>
                    Sikeresen másolva a vágólapra!
                </Alert>
            </Modal.Body>
        </Modal>
    )
}